export default {"src":"/_next/static/media/Star-filled.6f5d35eb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};